import SvgIcon, { SvgIconProps } from '../../SvgIcon'

const TwintIcon = (props: SvgIconProps) => (
  <SvgIcon width="800px" height="800px" viewBox="0 0 48 48" id="b" xmlns="http://www.w3.org/2000/svg" {...props}>
    <defs>
      <style>{'.c{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;}'}</style>
    </defs>
    <polyline className="c" points="17 37.8 3.2 24 17.1 10.2" />
    <polygon className="c" points="31.3 24 11.8 4.5 25.3 4.5 25.3 4.5 44.8 24 25.3 43.5 25.3 43.5 11.8 43.5 31.3 24" />
    <polyline className="c" points="23.8 31.1 16.7 24 23.8 16.9" />
    <polyline className="c" points="25.3 4.5 37.6 4.5 31.6 10.5" />
    <polyline className="c" points="31.6 37.5 37.6 43.5 25.3 43.5" />
  </SvgIcon>
)

export default TwintIcon
